import { Flex } from '@mantine/core';
import { MessageDirection } from '@chatscope/use-chat';
import { Message } from '../chat/hooks/useChatMessages';
import { SiestaMessage } from './SiestaMessage';
import { UserMessage } from './UserMessage';

type Props = {
  messages: Message[];
};

export function SiestaBarMessages({ messages }: Props) {
  return (
    <Flex direction="column" gap="md" px="md" py="md">
      {messages.map(message => {
        if (message.direction === MessageDirection.Outgoing) {
          return (
            <UserMessage
              key={message.id}
              content={message.answerContent || message.response[0]?.content || ''}
            />
          );
        }

        return (
          <SiestaMessage
            key={message.id}
            content={message.answerContent}
            thinkingContent={message.thinkingContent}
          />
        );
      })}
    </Flex>
  );
}
